import clsx from 'clsx';

import { DragHandle } from './DragHandle';
import { Header } from './Header';
import type { IconBadgeType } from './IconBadge';
import { IconBadge } from './IconBadge';
import { NameWrapper } from './NameWrapper';
import { OverflowGradientBlock } from './OverflowGradientBlock';
import { Wrapper } from './Wrapper';

const interactableClassName = 'select-text z-[var(--flow-z-node-interactable)]';
const contextMenuShared = 'w-sm4 h-sm4';
const contextMenuButtonWrapper = clsx(
  contextMenuShared,
  interactableClassName,
  'shrink-0',
);
const getContextMenuButtonClassName = (isOpen: boolean) =>
  clsx(
    contextMenuShared,
    'flex items-center justify-center',
    'opacity-0 group-hover:opacity-100',
    isOpen && 'opacity-100',
  );

export const NodeBase = {
  DragHandle,
  Header,
  IconBadge,
  NameWrapper,
  Wrapper,
  OverflowGradientBlock,
  interactable: interactableClassName,
  contextMenuButtonWrapper,
  getContextMenuButtonClassName,
};

export type { IconBadgeType };
